export default __webpack_public_path__ + "static/media/mobile-shipping-bg.5a94de1b.png";